export default __webpack_public_path__ + "locales/si/DataReassignmentDialog.json?hash=c2c5af018a737c6999a93aed5b0a8552";